import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setHasImportedCadData } from '../store/cadImport.actions'

export function* checkImportedCadData(pcrDoc: IPcr) {
  const importedCadData = pcrDoc.cadImport?.importedCadData
  if (importedCadData?.length) {
    yield put(setHasImportedCadData(true))
  }
}
